/**
 * Directional tilt right gesture
 * @module gestures/transforms/tiltRight
 */
import { createTiltGesture } from './tiltFactory.js';
export default createTiltGesture('right');
